var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4174 17.8869L10.396 17.8983L10.3904 17.9017H10.3881C10.2686 17.9661 10.1354 17.9998 10.0001 18C9.86487 18.0002 9.73159 17.9669 9.61187 17.9029L9.60962 17.9017L9.604 17.8983L9.58262 17.8869C9.13869 17.6415 8.70271 17.3816 8.27537 17.1075C7.25653 16.4563 6.28572 15.7306 5.37063 14.9361C3.30063 13.1225 1 10.4015 1 7.14217C1.0001 6.07874 1.32473 5.04149 1.92919 4.17324C2.53366 3.305 3.38822 2.64846 4.37523 2.29403C5.36223 1.9396 6.43312 1.90471 7.44045 2.19417C8.44778 2.48362 9.34201 3.08318 10 3.91029C10.658 3.08318 11.5522 2.48362 12.5595 2.19417C13.5669 1.90471 14.6378 1.9396 15.6248 2.29403C16.6118 2.64846 17.4663 3.305 18.0708 4.17324C18.6753 5.04149 18.9999 6.07874 19 7.14217C19 9.62967 17.6606 11.8036 16.1055 13.5",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5168,
    cy: 15.6667,
    r: 1.66667,
    fill: "#F7E237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTheme);
export default __webpack_public_path__ + "static/media/search_theme.a9bef557ee3613c8a548d45051f83ff7.svg";
export { ForwardRef as ReactComponent };